<template>
  <div v-if="pgLoading" class="loadingLogo">
    <img src="/assets/img/logo/charity-logo.png" alt="children's heart logo" />
  </div>
  <div v-else class="pt-md-5 mt-n10">
    <section class="counter-area pt-20 pt-md-70 pb-20">
      <div class="container">
        <div class="row">
          <div class="col-xl-3 col-lg-3 col-md-3 col-3 px-1">
            <div
              class="counetrs text-center wow fadeInUp2 animated"
              data-wow-delay=".1s"
            >
              <div class="counetrs__icon mb-20">
                <i class="flaticon-social-care"></i>
              </div>
              <div
                v-if="pgLoading"
                class="webkit-animation webkit-100-70"
              ></div>
              <h1
                :style="$i18n.locale == 'en' ? 'direction:rtl' : ''"
                v-if="!pgLoading"
              >
                <span class="counter">{{ projects }}</span> +
              </h1>
              <p>{{ $t("counter.projects") }}</p>
            </div>
          </div>

          <div class="col-xl-3 col-lg-3 col-md-3 col-3 px-1">
            <div
              class="counetrs text-center wow fadeInUp2 animated"
              data-wow-delay=".3s"
            >
              <div class="counetrs__icon mb-20">
                <i class="flaticon-donation"></i>
              </div>
              <div
                v-if="pgLoading"
                class="webkit-animation webkit-100-70"
              ></div>
              <h1
                :style="$i18n.locale == 'en' ? 'direction:rtl' : ''"
                v-if="!pgLoading"
              >
                <span class="counter">{{ clients }}</span> +
              </h1>
              <p>{{ $t("counter.clients") }}</p>
            </div>
          </div>

          <div class="col-xl-3 col-lg-3 col-md-3 col-3 px-1">
            <div
              class="counetrs text-center wow fadeInUp2 animated"
              data-wow-delay=".5s"
            >
              <div class="counetrs__icon mb-20">
                <i class="flaticon-charity"></i>
              </div>
              <div
                v-if="pgLoading"
                class="webkit-animation webkit-100-70"
              ></div>
              <h1
                :style="$i18n.locale == 'en' ? 'direction:rtl' : ''"
                v-if="!pgLoading"
              >
                <span class="counter">{{ orphans }}</span> +
              </h1>
              <p>{{ $t("counter.orphans") }}</p>
            </div>
          </div>

          <div class="col-xl-3 col-lg-3 col-md-3 col-3 px-1">
            <div
              class="counetrs text-center wow fadeInUp2 animated"
              data-wow-delay=".7s"
            >
              <div class="counetrs__icon mb-20">
                <i class="flaticon-community"></i>
              </div>
              <div
                v-if="pgLoading"
                class="webkit-animation webkit-100-70"
              ></div>
              <h1
                :style="$i18n.locale == 'en' ? 'direction:rtl' : ''"
                v-if="!pgLoading"
              >
                <span class="counter">{{ donations }}</span> +
              </h1>
              <p>{{ $t("counter.donations") }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "App",
  components: {},
  data() {
    return {
      //
      locale: "ar",
      pgLoading: true,

      projects: 0,
      clients: 0,
      orphans: 0,
      donations: 0,
    };
  },
  watch: {},
  created() {
    //
    if (localStorage.getItem("locale")) {
      this.locale = localStorage.getItem("locale");
    }

    this.fetchData();
  },
  methods: {
    //
    fetchData() {
      this.pgLoading = true;
      this.axios.defaults.headers.common = {
        "X-Requested-With": "XMLHttpRequest", // security to prevent CSRF attacks
      };
      const options = {
        url: window.baseURL + "/settings",
        method: "GET",
        data: {},
        params: {
          locale: this.locale,
        },
      };
      this.$axios(options)
        .then((res) => {
          this.pgLoading = false;
          this.projects = res.data.projects;
          this.clients = res.data.clients;
          this.orphans = res.data.orphans;
          this.donations = res.data.donations;
        })
        .catch(() => {})
        .finally(() => {});
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media (max-width: 767.98px) {
  .counter-area .counetrs__icon i {
    font-size: 37px;
  }

  .counetrs h1 {
    font-size: 25px;
  }

  .counetrs p {
    font-size: 10px;
  }
}
@media (min-width: 575.98px) {
  .pt-md-70 {
    padding-top: 70px;
  }
}
</style>
